import { fixEncoding } from "./encoding";

export type AtlasLanguage = "pt" | "en" | "es";

export const ATLAS_UI_LABELS = {
  pt: {
    diagnosis: "Diagn\u00f3stico",
    location: "Localiza\u00e7\u00e3o",
    aoOtaClassification: "Classifica\u00e7\u00e3o AO/OTA",
    strategy: "Estrat\u00e9gia",
    strategyChoiceTitle: "ESCOLHA DA ESTRAT\u00c9GIA PELO M\u00c9DICO",
    strategyChoiceSubtitle: "A IA organiza possibilidades; a decis\u00e3o final \u00e9 do m\u00e9dico.",
    strategyChoiceConservativeTitle: "TRATAMENTO CONSERVADOR",
    strategyChoiceConservativeDescription: "Conduta inicial estruturada, com reavalia\u00e7\u00e3o cl\u00ednica e crit\u00e9rios de convers\u00e3o.",
    strategyChoiceSurgicalTitle: "T\u00c9CNICA CIR\u00daRGICA",
    strategyChoiceSurgicalDescription: "Op\u00e7\u00e3o operat\u00f3ria detalhada, pronta para avalia\u00e7\u00e3o do m\u00e9dico assistente.",
    conservativeTreatment: "Tratamento Conservador",
    surgicalTechnique: "T\u00e9cnica Cir\u00fargica",
    scientificEvidence: "Evid\u00eancias Cient\u00edficas",
    requiredMaterials: "Materiais Necess\u00e1rios",
    techniqueComparison: "Compara\u00e7\u00e3o entre T\u00e9cnicas",
    selectionCriteria: "Crit\u00e9rio de Escolha",
    planB: "Plano B",
    postoperative: "P\u00f3s-operat\u00f3rio",
    differentialDiagnosis: "Diagn\u00f3sticos Diferenciais",
    recommendations: "Recomenda\u00e7\u00f5es",
    technique1: "T\u00e9cnica 1",
    technique2: "T\u00e9cnica 2",
    recommendedByAi: "Recomendada pela IA",
    latest: "Mais atual",
    alternative: "Alternativa",
    surgicalPlanLabel: "PLANEJAMENTO CL\u00cdNICO",
    surgicalPlanTitle: "Planejamento cir\u00fargico / conduta",
    surgicalPlanSubtitle: "T\u00f3picos cl\u00ednicos organizados para revis\u00e3o r\u00e1pida durante a consulta.",
    originalImageViewerTitle: "Exame original enviado",
    originalImageViewerReset: "Resetar",
    originalImageViewerFit: "Ajustar à tela",
    originalImageViewerZoomIn: "Zoom +",
    originalImageViewerZoomOut: "Zoom -",
    originalImageViewerPdfUnavailable: "Pré-visualização indisponível para PDF neste viewer.",
    originalImageViewerAlt: "Exame original enviado pelo médico",
    finalDecisionDisclaimer: "A decis\u00e3o final \u00e9 do cirurgi\u00e3o assistente. As op\u00e7\u00f5es abaixo organizam a an\u00e1lise da IA para revis\u00e3o cl\u00ednica.",
    noStructuredInfo: "Sem informa\u00e7\u00e3o estruturada.",
    classificationNotDefined: "Classifica\u00e7\u00e3o AO/OTA n\u00e3o definida",
    classificationApproximate: "Aproximada",
    classificationBasedOnFindings: "Classifica\u00e7\u00e3o AO/OTA baseada nos achados radiogr\u00e1ficos.",
    classificationApproximateBasedOnFindings: "Classifica\u00e7\u00e3o AO/OTA aproximada baseada nos achados radiogr\u00e1ficos.",
    medicalDecisionRequired: "Avalia\u00e7\u00e3o m\u00e9dica necess\u00e1ria",
    generalMaterials: "Materiais gerais do plano:",
    techniqueMaterials: "Materiais da T\u00e9cnica Cir\u00fargica {index}:",
    materialsNotSpecified: "Materiais n\u00e3o especificados pela IA. Revise conforme diagn\u00f3stico, idade, classifica\u00e7\u00e3o e disponibilidade hospitalar.",
    techniqueFallback: "T\u00e9cnica cir\u00fargica sugerida {index}",
    techniqueAlternativeFallback: "T\u00e9cnica cir\u00fargica alternativa",
    save: "Salvar",
    whyAiRecommends: "Por que a IA recomenda",
    whenOtherPreferred: "Quando a outra t\u00e9cnica pode ser prefer\u00edvel",
    indication: "Indica\u00e7\u00e3o",
    whenToChoose: "Quando escolher",
    advantages: "Vantagens",
    limitationsRisks: "Limita\u00e7\u00f5es / riscos",
    stepByStep: "Passo a passo",
    practicalNotes: "Observa\u00e7\u00f5es pr\u00e1ticas",
    evidenceArticle: "Artigo {index}",
    validated: "Validada",
    pubmedSearch: "Busca PubMed",
    viewDoi: "Ver DOI",
    viewPubMed: "Ver no PubMed",
    evidenceNeedsValidation: "Algumas refer\u00eancias precisam de valida\u00e7\u00e3o adicional.",
    viewScientificEvidence: "Ver evid\u00eancias cient\u00edficas",
    evidenceBasedConsensus: "Evid\u00eancia baseada em consenso cl\u00ednico e pr\u00e1tica ortop\u00e9dica estabelecida.",
    techniqueComparisonNoSafeSelection: "A IA n\u00e3o conseguiu definir superioridade t\u00e9cnica com seguran\u00e7a; decis\u00e3o deve considerar experi\u00eancia do cirurgi\u00e3o e recursos dispon\u00edveis.",
    selectionCriteriaDefault: "Crit\u00e9rio de escolha: considerar localiza\u00e7\u00e3o exata, estabilidade, qualidade \u00f3ssea, partes moles, morbidade de acesso e experi\u00eancia do cirurgi\u00e3o.",
    selectionCriteriaSurgicalOnly: "A decis\u00e3o final deve ser tomada pelo cirurgi\u00e3o assistente com base na \u00fanica t\u00e9cnica sustentada pelo caso.",
    planBNoSafeSelection: "A IA n\u00e3o conseguiu definir superioridade t\u00e9cnica com seguran\u00e7a; decis\u00e3o deve considerar experi\u00eancia do cirurgi\u00e3o e recursos dispon\u00edveis.",
    techniqueNoDetail: "T\u00e9cnica cir\u00fargica n\u00e3o detalhada para este caso.",
    comparisonTitle: "Compara\u00e7\u00e3o entre t\u00e9cnicas",
    criteriaTitle: "Crit\u00e9rio de escolha",
    planBContingency: "Plano B (Conting\u00eancia)",
    postoperativeCare: "Cuidados p\u00f3s-operat\u00f3rios",
    techniqueSuggestedTitle: "T\u00e9cnica cir\u00fargica sugerida",
    mainFindings: "Achados principais",
    automaticMeasurements: "Medi\u00e7\u00f5es autom\u00e1ticas",
    materials: "Materiais e OPME",
    technique: "T\u00e9cnica / Conduta",
    tips: "Dicas e armadilhas",
    fractureLine: "Linha da fratura",
    cystArea: "\u00c1rea c\u00edstica",
    discHernia: "H\u00e9rnia de disco",
    ligamentLesion: "Les\u00e3o ligamentar",
    tendonLesion: "Les\u00e3o tend\u00ednea",
    clinicalPanel: "Painel Cl\u00ednico",
    structuredClinicalAnalysis: "An\u00e1lise cl\u00ednica estruturada",
    report: "Relat\u00f3rio",
    loadingProgress: "Acompanhe o progresso da gera\u00e7\u00e3o no Atlas",
  },
  en: {
    diagnosis: "Diagnosis",
    location: "Location",
    aoOtaClassification: "AO/OTA Classification",
    strategy: "Strategy",
    strategyChoiceTitle: "STRATEGY CHOSEN BY THE PHYSICIAN",
    strategyChoiceSubtitle: "AI organizes the possibilities; the final decision is the physician's.",
    strategyChoiceConservativeTitle: "CONSERVATIVE TREATMENT",
    strategyChoiceConservativeDescription: "Structured initial management, with clinical reassessment and conversion criteria.",
    strategyChoiceSurgicalTitle: "SURGICAL TECHNIQUE",
    strategyChoiceSurgicalDescription: "Detailed operative option, ready for review by the attending physician.",
    conservativeTreatment: "Conservative Treatment",
    surgicalTechnique: "Surgical Technique",
    scientificEvidence: "Scientific Evidence",
    requiredMaterials: "Required Materials",
    techniqueComparison: "Technique Comparison",
    selectionCriteria: "Selection Criteria",
    planB: "Plan B",
    postoperative: "Postoperative",
    differentialDiagnosis: "Differential Diagnoses",
    recommendations: "Recommendations",
    technique1: "Technique 1",
    technique2: "Technique 2",
    recommendedByAi: "Recommended by AI",
    latest: "Latest",
    alternative: "Alternative",
    surgicalPlanLabel: "CLINICAL PLANNING",
    surgicalPlanTitle: "Surgical planning / management",
    surgicalPlanSubtitle: "Clinical topics organized for fast review during care.",
    originalImageViewerTitle: "Original exam uploaded",
    originalImageViewerReset: "Reset",
    originalImageViewerFit: "Fit to screen",
    originalImageViewerZoomIn: "Zoom +",
    originalImageViewerZoomOut: "Zoom -",
    originalImageViewerPdfUnavailable: "Preview unavailable for PDF in this viewer.",
    originalImageViewerAlt: "Original exam uploaded by the physician",
    finalDecisionDisclaimer: "Final decision belongs to the attending surgeon. The options below organize the AI analysis for clinical review.",
    noStructuredInfo: "No structured information.",
    classificationNotDefined: "AO/OTA classification not defined",
    classificationApproximate: "Approximate",
    classificationBasedOnFindings: "AO/OTA classification based on radiographic findings.",
    classificationApproximateBasedOnFindings: "Approximate AO/OTA classification based on radiographic findings.",
    medicalDecisionRequired: "Medical evaluation required",
    generalMaterials: "General plan materials:",
    techniqueMaterials: "Materials for Surgical Technique {index}:",
    materialsNotSpecified: "Materials not specified by AI. Review according to diagnosis, age, classification and hospital availability.",
    techniqueFallback: "Suggested surgical technique {index}",
    techniqueAlternativeFallback: "Alternative surgical technique",
    save: "Save",
    whyAiRecommends: "Why AI recommends",
    whenOtherPreferred: "When the other technique may be preferable",
    indication: "Indication",
    whenToChoose: "When to choose",
    advantages: "Advantages",
    limitationsRisks: "Limitations / risks",
    stepByStep: "Step by step",
    practicalNotes: "Practical notes",
    evidenceArticle: "Article {index}",
    validated: "Validated",
    pubmedSearch: "PubMed search",
    viewDoi: "View DOI",
    viewPubMed: "View on PubMed",
    evidenceNeedsValidation: "Some references need additional validation.",
    viewScientificEvidence: "View scientific evidence",
    evidenceBasedConsensus: "Evidence based on clinical consensus and established orthopedic practice.",
    techniqueComparisonNoSafeSelection: "The AI could not determine technical superiority with confidence; decision should consider surgeon experience and available resources.",
    selectionCriteriaDefault: "Selection criteria: consider exact location, stability, bone quality, soft tissues, access morbidity and surgeon experience.",
    selectionCriteriaSurgicalOnly: "The final decision must be made by the attending surgeon based on the only technique supported by the case.",
    planBNoSafeSelection: "The AI could not determine technical superiority with confidence; decision should consider surgeon experience and available resources.",
    techniqueNoDetail: "Surgical technique not detailed for this case.",
    comparisonTitle: "Technique comparison",
    criteriaTitle: "Selection criteria",
    planBContingency: "Plan B (Contingency)",
    postoperativeCare: "Postoperative care",
    techniqueSuggestedTitle: "Suggested surgical technique",
    mainFindings: "Main findings",
    automaticMeasurements: "Automatic measurements",
    materials: "Materials",
    technique: "Technique / Management",
    tips: "Tips and pitfalls",
    fractureLine: "Fracture line",
    cystArea: "Cystic area",
    discHernia: "Disc hernia",
    ligamentLesion: "Ligament lesion",
    tendonLesion: "Tendon lesion",
    clinicalPanel: "Clinical Panel",
    structuredClinicalAnalysis: "Structured clinical analysis",
    report: "Report",
    loadingProgress: "Track the Atlas generation progress",
  },
  es: {
    diagnosis: "Diagn\u00f3stico",
    location: "Localizaci\u00f3n",
    aoOtaClassification: "Clasificaci\u00f3n AO/OTA",
    strategy: "Estrategia",
    strategyChoiceTitle: "ELECCIÓN DE LA ESTRATEGIA POR EL MÉDICO",
    strategyChoiceSubtitle: "La IA organiza las posibilidades; la decisión final es del médico.",
    strategyChoiceConservativeTitle: "TRATAMIENTO CONSERVADOR",
    strategyChoiceConservativeDescription: "Conducta inicial estructurada, con reevaluación clínica y criterios de conversión.",
    strategyChoiceSurgicalTitle: "TÉCNICA QUIRÚRGICA",
    strategyChoiceSurgicalDescription: "Opción quirúrgica detallada, lista para evaluación del médico tratante.",
    conservativeTreatment: "Tratamiento Conservador",
    surgicalTechnique: "T\u00e9cnica Quir\u00fargica",
    scientificEvidence: "Evidencia Cient\u00edfica",
    requiredMaterials: "Materiales Necesarios",
    techniqueComparison: "Comparaci\u00f3n de T\u00e9cnicas",
    selectionCriteria: "Criterio de Selecci\u00f3n",
    planB: "Plan B",
    postoperative: "Postoperatorio",
    differentialDiagnosis: "Diagn\u00f3sticos Diferenciales",
    recommendations: "Recomendaciones",
    technique1: "T\u00e9cnica 1",
    technique2: "T\u00e9cnica 2",
    recommendedByAi: "Recomendada por IA",
    latest: "M\u00e1s actual",
    alternative: "Alternativa",
    surgicalPlanLabel: "PLANIFICACI\u00d3N CL\u00cdNICA",
    surgicalPlanTitle: "Planificaci\u00f3n quir\u00fargica / conducta",
    surgicalPlanSubtitle: "Temas cl\u00ednicos organizados para una revisi\u00f3n r\u00e1pida durante la consulta.",
    originalImageViewerTitle: "Examen original enviado",
    originalImageViewerReset: "Restablecer",
    originalImageViewerFit: "Ajustar a la pantalla",
    originalImageViewerZoomIn: "Zoom +",
    originalImageViewerZoomOut: "Zoom -",
    originalImageViewerPdfUnavailable: "Vista previa no disponible para PDF en este visor.",
    originalImageViewerAlt: "Examen original enviado por el médico",
    finalDecisionDisclaimer: "La decisi\u00f3n final corresponde al cirujano tratante. Las opciones siguientes organizan el an\u00e1lisis de la IA para revisi\u00f3n cl\u00ednica.",
    noStructuredInfo: "Sin informaci\u00f3n estructurada.",
    classificationNotDefined: "Clasificaci\u00f3n AO/OTA no definida",
    classificationApproximate: "Aproximada",
    classificationBasedOnFindings: "Clasificaci\u00f3n AO/OTA basada en los hallazgos radiogr\u00e1ficos.",
    classificationApproximateBasedOnFindings: "Clasificaci\u00f3n AO/OTA aproximada basada en los hallazgos radiogr\u00e1ficos.",
    medicalDecisionRequired: "Evaluaci\u00f3n m\u00e9dica necesaria",
    generalMaterials: "Materiales generales del plan:",
    techniqueMaterials: "Materiales de la T\u00e9cnica Quir\u00fargica {index}:",
    materialsNotSpecified: "Materiales no especificados por IA. Revisar seg\u00fan diagn\u00f3stico, edad, clasificaci\u00f3n y disponibilidad hospitalaria.",
    techniqueFallback: "T\u00e9cnica quir\u00fargica sugerida {index}",
    techniqueAlternativeFallback: "T\u00e9cnica quir\u00fargica alternativa",
    save: "Guardar",
    whyAiRecommends: "Por qu\u00e9 la IA recomienda",
    whenOtherPreferred: "Cu\u00e1ndo la otra t\u00e9cnica puede ser preferible",
    indication: "Indicaci\u00f3n",
    whenToChoose: "Cu\u00e1ndo elegir",
    advantages: "Ventajas",
    limitationsRisks: "Limitaciones / riesgos",
    stepByStep: "Paso a paso",
    practicalNotes: "Observaciones pr\u00e1cticas",
    evidenceArticle: "Art\u00edculo {index}",
    validated: "Validada",
    pubmedSearch: "B\u00fasqueda PubMed",
    viewDoi: "Ver DOI",
    viewPubMed: "Ver en PubMed",
    evidenceNeedsValidation: "Algunas referencias necesitan validaci\u00f3n adicional.",
    viewScientificEvidence: "Ver evidencia cient\u00edfica",
    evidenceBasedConsensus: "Evidencia basada en consenso cl\u00ednico y pr\u00e1ctica ortop\u00e9dica establecida.",
    techniqueComparisonNoSafeSelection: "La IA no pudo definir superioridad t\u00e9cnica con seguridad; la decisi\u00f3n debe considerar la experiencia del cirujano y los recursos disponibles.",
    selectionCriteriaDefault: "Criterio de selecci\u00f3n: considerar localizaci\u00f3n exacta, estabilidad, calidad \u00f3sea, partes blandas, morbimortalidad del acceso y experiencia del cirujano.",
    selectionCriteriaSurgicalOnly: "La decisi\u00f3n final debe ser tomada por el cirujano tratante con base en la \u00fanica t\u00e9cnica sustentada por el caso.",
    planBNoSafeSelection: "La IA no pudo definir superioridad t\u00e9cnica con seguridad; la decisi\u00f3n debe considerar la experiencia del cirujano y los recursos disponibles.",
    techniqueNoDetail: "T\u00e9cnica quir\u00fargica no detallada para este caso.",
    comparisonTitle: "Comparaci\u00f3n entre t\u00e9cnicas",
    criteriaTitle: "Criterio de selecci\u00f3n",
    planBContingency: "Plan B (Contingencia)",
    postoperativeCare: "Cuidados postoperatorios",
    techniqueSuggestedTitle: "T\u00e9cnica quir\u00fargica sugerida",
    mainFindings: "Hallazgos principales",
    automaticMeasurements: "Mediciones autom\u00e1ticas",
    materials: "Materiales",
    technique: "T\u00e9cnica / Conducta",
    tips: "Consejos y trampas",
    fractureLine: "L\u00ednea de fractura",
    cystArea: "\u00c1rea qu\u00edstica",
    discHernia: "Hernia discal",
    ligamentLesion: "Lesi\u00f3n ligamentaria",
    tendonLesion: "Lesi\u00f3n tendinosa",
    clinicalPanel: "Panel Cl\u00ednico",
    structuredClinicalAnalysis: "An\u00e1lisis cl\u00ednico estructurado",
    report: "Informe",
    loadingProgress: "Siga el progreso de generaci\u00f3n en Atlas",
  },
} as const;

const mojibakeReplacements: Array<[RegExp, string]> = [
  [/\u00c3\u00a1/g, "\u00e1"],
  [/\u00c3\u00a9/g, "\u00e9"],
  [/\u00c3\u00ad/g, "\u00ed"],
  [/\u00c3\u00b3/g, "\u00f3"],
  [/\u00c3\u00ba/g, "\u00fa"],
  [/\u00c3\u00a3/g, "\u00e3"],
  [/\u00c3\u00b5/g, "\u00f5"],
  [/\u00c3\u00a7/g, "\u00e7"],
  [/\u00c3\u0089/g, "\u00c9"],
  [/\u00c3\u0093/g, "\u00d3"],
  [/\u00c3\u0080/g, "\u00c0"],
  [/\u00c3\u0082/g, "\u00c2"],
  [/\u00c3\u008a/g, "\u00ca"],
  [/\u00c3\u008d/g, "\u00cd"],
  [/\u00c3\u009c/g, "\u00dc"],
  [/\u00c3\u00b1/g, "\u00f1"],
  [/\u00c3\u00a8/g, "\u00e8"],
  [/\u00c3\u00aa/g, "\u00ea"],
  [/\u00c3\u00b4/g, "\u00f4"],
  [/\u00c3\u00a2/g, "\u00e2"],
  [/\u00e2\u20ac\u2122/g, "'"],
  [/\u00e2\u20ac\u0153/g, '"'],
  [/\u00e2\u20ac/g, '"'],
  [/\u00c2/g, ""],
  [/\ufffd/g, ""],
];

const languageSpecificReplacements: Record<AtlasLanguage, Array<[RegExp, string]>> = {
  pt: [],
  en: [
    [/\bDiagn\u00f3stico\b/g, "Diagnosis"],
    [/\bAchados principais\b/g, "Main findings"],
    [/\bMedi\u00e7\u00f5es autom\u00e1ticas\b/g, "Automatic measurements"],
    [/\bMateriais e OPME\b/g, "Materials"],
    [/\bT\u00e9cnica \/ Conduta\b/g, "Technique / Management"],
    [/\bDicas e armadilhas\b/g, "Tips and pitfalls"],
    [/\bPlano B\b/g, "Plan B"],
    [/\bEvid\u00eancias cient\u00edficas\b/g, "Scientific evidence"],
    [/\b\u00c1rea c\u00edstica\b/g, "Cystic area"],
    [/\bH\u00e9rnia de disco\b/g, "Disc hernia"],
    [/\bLes\u00e3o ligamentar\b/g, "Ligament lesion"],
    [/\bLes\u00e3o tend\u00ednea\b/g, "Tendon lesion"],
  ],
  es: [
    [/\bDiagnosis\b/g, "Diagn\u00f3stico"],
    [/\bMain findings\b/g, "Hallazgos principales"],
    [/\bAutomatic measurements\b/g, "Mediciones autom\u00e1ticas"],
    [/\bMaterials\b/g, "Materiales"],
    [/\bTechnique \/ Management\b/g, "T\u00e9cnica / Conducta"],
    [/\bTips and pitfalls\b/g, "Consejos y trampas"],
    [/\bScientific evidence\b/g, "Evidencia cient\u00edfica"],
  ],
};

export const normalizeAtlasEncoding = (text: string): string =>
  fixEncoding(String(text ?? ""))
    .normalize("NFC")
    .replace(/\u00c3\u0083\u00c2\u00a1/g, "\u00e1")
    .replace(/\u00c3\u0083\u00c2\u00a9/g, "\u00e9")
    .replace(/\u00c3\u0083\u00c2\u00ad/g, "\u00ed")
    .replace(/\u00c3\u0083\u00c2\u00b3/g, "\u00f3")
    .replace(/\u00c3\u0083\u00c2\u00ba/g, "\u00fa")
    .replace(/\u00c3\u0083\u00c2\u00a3/g, "\u00e3")
    .replace(/\u00c3\u0083\u00c2\u00b5/g, "\u00f5")
    .replace(/\u00c3\u0083\u00c2\u00a7/g, "\u00e7")
    .replace(/\u00c3\u0083\u00e2\u20ac\u0160/g, "\u00c9")
    .replace(/\u00c3\u0083\u00e2\u20ac\u0153/g, "\u00d3")
    .replace(/\u00c3\u0083\u00e2\u201a\u00ac/g, "\u00c0")
    .replace(/\u00c3\u0083\u00e2\u20ac\u0161/g, "\u00c2")
    .replace(/\u00c3\u0083\u00c5\xa0/g, "\u00ca")
    .replace(/\u00c3\u0083\u00c2\u008d/g, "\u00cd")
    .replace(/\u00c3\u0083\u00c5\u201c/g, "\u00dc")
    .replace(/\u00c3\u0083\u00c2\u00b1/g, "\u00f1")
    .replace(/\u00c3\u0083\u00c2\u00a8/g, "\u00e8")
    .replace(/\u00c3\u0083\u00c2\u00aa/g, "\u00ea")
    .replace(/\u00c3\u0083\u00c2\u00b4/g, "\u00f4")
    .replace(/\u00c3\u0083\u00c2\u00a2/g, "\u00e2")
    .replace(/\u00e2\u20ac\u2122/g, "'")
    .replace(/\u00e2\u20ac\u0153/g, '"')
    .replace(/\u00e2\u20ac/g, '"')
    .replace(/\u00c2/g, "")
    .replace(/\ufffd/g, "");

export const normalizePortugueseEncoding = (text: string): string => normalizeAtlasEncoding(text);

const applyLanguageSpecificReplacements = (text: string, language: AtlasLanguage): string =>
  languageSpecificReplacements[language].reduce(
    (acc, [pattern, replacement]) => acc.replace(pattern, replacement),
    text
  );

export const normalizeAtlasText = (text: string, language: AtlasLanguage): string => {
  const encodingFixed = normalizeAtlasEncoding(text);
  return applyLanguageSpecificReplacements(encodingFixed, language).normalize("NFC");
};

export const atlasLabel = (language: AtlasLanguage, key: keyof typeof ATLAS_UI_LABELS.pt) =>
  ATLAS_UI_LABELS[language][key] ?? ATLAS_UI_LABELS.pt[key];
